<template xmlns="http://www.w3.org/1999/html">

  <div style="height: 100vh;width: 100vw;
  position:relative;
    background: url(/static/images/lbt/bg.png) no-repeat;
    background-attachment:fixed;
    background-size:cover;">


    <img src="/static/images/lbt/logo.png" style="width: 54vw;position: absolute;top:5vh;left: 23vw;" />

    <div style="width: 100vw;position: absolute;top:22vh;display: flex;justify-content: center;">
      <img src="/static/images/lbt/query-content.png" style="height: 70vh;width: 80vw;" />
    </div>

    <div
      style="width: 100vw;position: absolute;top:22vh;display: flex;height: 70vh;flex-direction: column;align-items: center;justify-content:space-around;">
      <img src="/static/images/lbt/anti-query.png" style="width: 25vw;margin-top: 3vh;" />
      <div style="width: 100%;display: flex;flex-direction: column;align-items: center;">
        <img src="/static/images/lbt/scan.png" style="width: 60vw;" @click="openScan" />
        <span style="color: rgb(173, 137, 89);font-size: 2.6vw;margin-top: -5px;">扫描商品内包装二维码查验商品是否为正品</span>
      </div>



      <input type="text" v-model="antiCode" style="width: 53vw;height: 40px;border-radius: 6px;
        border: 1px solid rgb(173, 137, 89);
        box-shadow: 0 0 12px rgba(173, 137, 89, 0.8);text-align: center;" />

      <img src="/static/images/lbt/query-button.png" style="width: 60vw;" @click="queryAnti" />
      <div style="width: 100vw;display: flex;flex-direction: column;align-items: center;margin-bottom: 3vh;">
        <img src="/static/images/lbt/tip.png" style="width: 25vw;" />
        <img src="/static/images/lbt/query-tip.png" style="width: 55vw;margin-top: 1.5vh;" />
      </div>
    </div>


  </div>


</template>



<script>
import { getAntiData, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      antiCode: "",
      eno: "138562290170",
    }
  },
  methods: {
    openScan() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          this.antiCode = scanQRCode
          this.queryAnti()
        }
      })
    },
    queryAnti() {
      if (this.antiCode == '' || this.antiCode.length != 16) {
        alert("请输入16位防伪码进行查询验证")
      } else {
        this.$router.push({
          path: '/lbt.query',
          query: {
            eno: this.eno,
            c: this.antiCode
          }
        })
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx885161c495be58a3").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted: function () {
    this.getWxJs()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LiuBaoTang/Index.vue